/**
 * Token uniqueness for template editor (local copy so template folder resolves at build time).
 * Single-instance tokens must appear at most once. See also client/src/utils/tokenUniquity.js.
 */

export const UNIQUE_TOKEN_KEYS = [
  'invoice.items_table',
  'invoice.line_items',
  'estimate.items_table',
  'estimate.line_items',
  'invoice.totals_section',
  'totals_section',
  'invoice.notes_section',
  'notes_section',
  'invoice.company_logo',
  'company_logo',
];

function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function hasTokenKeyInHtml(html, key) {
  if (!html || typeof html !== 'string' || !key) return false;
  const escapedKey = escapeRegex(key);
  const regex = new RegExp(
    `<[^>]*\\bclass="[^"]*merge-token[^"]*"[^>]*\\bdata-key="${escapedKey}"[^>]*>|<[^>]*\\bdata-key="${escapedKey}"[^>]*\\bclass="[^"]*merge-token[^"]*"[^>]*>`,
    'i'
  );
  return regex.test(html);
}

export function hasTokenKey(quillOrHtml, key) {
  if (!key) return false;
  if (typeof quillOrHtml === 'string') return hasTokenKeyInHtml(quillOrHtml, key);
  const quill = quillOrHtml;
  if (quill?.root) return hasTokenKeyInHtml(quill.root.innerHTML || '', key);
  if (quill?.getContents) {
    const delta = quill.getContents();
    if (delta?.ops) {
      for (const op of delta.ops) {
        if (op.insert && typeof op.insert === 'object' && op.insert.mergeToken && op.insert.mergeToken.key === key)
          return true;
      }
    }
  }
  return false;
}

export function isUniqueTokenKey(key) {
  return UNIQUE_TOKEN_KEYS.includes(key);
}

export function stripExistingUniqueTokensFromHtml(html, existingKeys) {
  if (!html || !existingKeys?.length) return html;
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  doc.querySelectorAll('.merge-token[data-key]').forEach((el) => {
    const k = el.getAttribute('data-key');
    if (k && existingKeys.includes(k)) el.remove();
  });
  return doc.body.innerHTML;
}
